if (window.__modalScrollLockLoaded) {} else {
  window.__modalScrollLockLoaded = true;

  (() => {
    const MODAL_SELECTOR = '#PopupModal-kolekcje';
    const SCROLLER_SELECTOR = '#PopupModal-kolekcje .modal-products, #PopupModal-kolekcje .scroll-box, #PopupModal-kolekcje .js-modal-scroll';

    let scrollY = 0;
    let startY = 0;

    function lockScroll() {
      scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('is-locked');
      document.body.classList.add('is-locked');
      document.body.style.top = `-${scrollY}px`;
    }

    function unlockScroll() {
      document.documentElement.classList.remove('is-locked');
      document.body.classList.remove('is-locked');
      const y = Math.abs(parseInt(document.body.style.top || '0', 10)) || 0;
      document.body.style.top = '';
      window.scrollTo(0, y);
    }

    const watchModal = (modal) => {
      if (!modal || modal.__lockObs) return;
      const obs = new MutationObserver(muts => {
        muts.forEach(m => {
          if (m.type === 'attributes' && m.attributeName === 'open') {
            modal.hasAttribute('open') ? lockScroll() : unlockScroll();
          }
        });
      });
      obs.observe(modal, { attributes: true, attributeFilter: ['open'] });
      modal.__lockObs = obs;
    };

    const init = () => {
      const modal = document.querySelector(MODAL_SELECTOR);
      if (modal) watchModal(modal);
    };

    (document.readyState === 'loading')
      ? document.addEventListener('DOMContentLoaded', init)
      : init();

    new MutationObserver(muts => {
      muts.forEach(m => {
        m.addedNodes?.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches?.(MODAL_SELECTOR)) watchModal(node);
          node.querySelectorAll?.(MODAL_SELECTOR).forEach(watchModal);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    function canScroll(el, deltaY) {
      if (!el) return false;
      const max = el.scrollHeight - el.clientHeight;
      if (max <= 0) return false;
      const top = el.scrollTop;
      if (top <= 0 && deltaY > 0) return false;
      if (top >= max && deltaY < 0) return false;
      return true;
    }

    document.addEventListener('touchstart', (e) => {
      if (!document.body.classList.contains('is-locked')) return;
      startY = e.touches[0].clientY;
    }, { passive: false });

    document.addEventListener('touchmove', (e) => {
      if (!document.body.classList.contains('is-locked')) return;

      const scroller = e.target.closest(SCROLLER_SELECTOR);
      if (!scroller) {
        e.preventDefault();
        return;
      }

      const currentY = e.touches[0].clientY;
      const deltaY = currentY - startY;
      if (!canScroll(scroller, deltaY)) {
        e.preventDefault();
      }
    }, { passive: false });
  })();
}
